/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Modal, Button } from 'reactstrap';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../assets/styles/style.sass';
import s2 from '../../routes/order/Order.sass';
import { addOrderAddress } from '../../actions/order';
import { getStaticMapUrl } from '../../api/map';

class StaticMapDialog extends React.Component {
  static propTypes = {
    modal: PropTypes.bool.isRequired,
    onClickShow: PropTypes.func.isRequired,
    location: PropTypes.shape({
      lat: PropTypes.number,
      lon: PropTypes.number,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    const locations = {
      locations: {
        location: props.location,
      },
    };
    this.state = {
      staticMapUrl: getStaticMapUrl(locations, 16, null),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.location) {
      const locations = [];
      locations.push({ location: nextProps.location });
      this.setState({ staticMapUrl: getStaticMapUrl(locations, 16, null) });
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modal}
        toggle={() => {
          this.props.onClickShow();
        }}
        className={`${s.infoPopup} ${s2.staticMapInfo}`}
      >
        <Button
          outline
          color="link"
          onClick={() => {
            this.props.onClickShow();
          }}
          className={`${s2.infoCloseRightButton}`}
        />
        <img
          className={s2.staticMap}
          src={this.state.staticMapUrl}
          alt="staticMap"
        />
      </Modal>
    );
  }
}
const mapState = state => ({
  address: state.order.address,
});

const mapDispatch = {
  addOrderAddress,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(StaticMapDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/StaticMapDialog.js